import { render, staticRenderFns } from "./BalanceTable.vue?vue&type=template&id=4c479f34"
import script from "./BalanceTable.vue?vue&type=script&lang=js"
export * from "./BalanceTable.vue?vue&type=script&lang=js"
import style0 from "./BalanceTable.vue?vue&type=style&index=0&id=4c479f34&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports